import {Modal} from 'bootstrap';

export function closeModalsOnRouteChange(router, {browser = window, modalApi = Modal} = {}) {
    return router.afterEach((to, from, failure) => {
        if (failure || to.fullPath === from.fullPath) {
            return;
        }

        browser.document.querySelectorAll('.modal.show').forEach((modal) => {
            modalApi.getInstance(modal)?.hide();
        });
    });
}
